export const MAX_TAGS = 20;
export const MAX_TAG_LENGTH = 128;
export const VALID_TAG_PATTERN = /^[a-zA-Z0-9- ]+$/;

export type TagValidationError = 'tagTooLong' | 'invalidTagCharacters';

export function validateTag(tag: string): TagValidationError | null {
  if (tag.length > MAX_TAG_LENGTH) return 'tagTooLong';
  if (!VALID_TAG_PATTERN.test(tag)) return 'invalidTagCharacters';
  return null;
}

export function isDuplicateTag(tag: string, existingTags: string[]): boolean {
  return existingTags.some(
    (existing) => existing.toLowerCase() === tag.toLowerCase(),
  );
}

export function isAtTagLimit(tags: string[]): boolean {
  return tags.length >= MAX_TAGS;
}
